/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Fact3Inputs */

const en_dr_room_fact3 = /** @type {(inputs: Dr_Room_Fact3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A hypothesis-then-test approach across 759 startups (4 RCTs) produced better performance and fewer false positives (Camuffo et al. 2020/2024).`)
};

const id_dr_room_fact3 = /** @type {(inputs: Dr_Room_Fact3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendekatan hipotesis-lalu-uji pada 759 startup (4 RCT) menghasilkan performa lebih baik dan lebih sedikit false-positive (Camuffo dkk. 2020/2024).`)
};

/**
* | output |
* | --- |
* | "A hypothesis-then-test approach across 759 startups (4 RCTs) produced better performance and fewer false positives (Camuffo et al. 2020/2024)." |
*
* @param {Dr_Room_Fact3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_fact3 = /** @type {((inputs?: Dr_Room_Fact3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Fact3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_fact3(inputs)
	return en_dr_room_fact3(inputs)
});